module.exports = __webpack_public_path__ + "static/pu-alt-b8b311b61938e7cdfa9dc73b52a95d69.svg";